import { TherapistAction } from "src/redux/actions/constant";

const intialState: object = {
    response: null,
    isGetTherapistTask: false,
    data: [],
    loading: false,
    // THIN-7718: discipline this response was requested for, so consumers can drop a
    // late response belonging to a board the user has already navigated away from.
    // Mirrors the localDate echo in therapistListReducer.
    discipline: '',
};

export const getAllTherapistTaskReducer = (state = intialState, action: any) => {
    switch (action.type) {
        case TherapistAction.GET_ALL_THERAPIST_TASK_SUCCESS: {
            return {
                ...state,
                response: action.payload,
                isGetTherapistTask: true,
                data: action.payload.data,
                loading: false,
                discipline: action.payload?.discipline,
            };
        }
        case TherapistAction.GET_ALL_THERAPIST_TASK_FAILURE: {
            return {
                ...state,
                response: action.payload,
                isGetTherapistTask: false,
                loading: false,
                discipline: action.payload?.discipline,
            };
        }
        case TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case TherapistAction.GET_ALL_THERAPIST_TASK_RESET:
            return intialState;

        default:
            return state;
    }
};
